import { bundledResources, i18n } from '@askable/i18n';
import { LANGUAGES } from '@askableorg/i18n';
import { initReactI18next } from 'react-i18next';

import type { LocaleBackendOptions } from '@askable/i18n';

const initialLang =
  typeof window !== 'undefined'
    ? (document.cookie
        .split('; ')
        .find(row => row.startsWith('lang='))
        ?.split('=')[1] ??
      window.localStorage.getItem('lang') ??
      navigator.language ??
      'en')
    : 'en';

export const i18nReady = i18n.use(initReactI18next).init({
  lng: initialLang,
  fallbackLng: 'en',
  ns: ['clients', 'common', 'zod', 'components', 'docbuilder'],
  resources: bundledResources(['clients', 'components', 'docbuilder']),
  // Left out of `ns`, so it loads when a study flow preview first asks for it.
  backend: {
    namespaceLoaders: {
      studyFlow: async language => (await import('@askable/study-flow/i18n')).loadStudyFlowLocale(language),
    },
  } satisfies LocaleBackendOptions,
  // Only English is bundled. Without this flag i18next never asks the backend for other locales.
  partialBundledLanguages: true,
  // React escapes everything it renders, so i18next escaping interpolated values on top of
  // that double-encodes them - a category named "Account & Support" reached the UI as
  // "Account &amp; Support". Nothing here feeds translated output into innerHTML.
  interpolation: { escapeValue: false },
});

export default i18n;
export { LANGUAGES };
